import _ from "lodash";
import * as z from "../../../framework";
import { userHasRight } from "../../../framework";
import * as ui from "../../../framework/components/components";
import { RightLockable } from "../../../framework/components/components/component";
import { InputOptions } from "../../../framework/components/components/input";
import K_Input from "../../../framework/components/templates/K_Input";

export interface ComboBoxOptions extends InputOptions, kendo.ui.ComboBoxOptions {
    bindNumberValue?: string;
    entityType?: string;
    valueField?: string;
    url?: string;
    filterType?: string;
    width?: number;
    systemCode?: boolean | "true";
    labelField?: string;
    columnHeader1?: string;
    columnHeader2?: string;
    columnValue1?: string;
    columnValue2?: string;
    bindNumberValueText?: string;
    rowTemplate?: string;
    woopField?: string;
    preFilter?: string;
    filterFields?: string[];
    getDefaultDivisionId?: () => number;
    bindClass?: string;
    bindNameValue?: string;
    isComboBox?: boolean;
    requiredRight?: string;
    disabled?: boolean;
}

export class ComboBox extends ui.TemplateComponent {

    options: ComboBoxOptions & RightLockable;

    /*
    * creates a ComboBox component based on the Kendo ComboBox control
    *
    *  These parameters are only used if no rowTemplate value is provided:
    *   columnValue1
    *   columnValue2
    *
    *  These parameters are only used if no headerTemplate value is provided:
    *   columnHeader1
    *   columnHeader2

    *  These parameters are only used if the url parameter value is provided:
    *   filterType
    *   filterFields
    *   preFilter
    */
    constructor(options: ComboBoxOptions) {
        super(K_Input, options);
    }

    preRender() {
        const options = this.options;

        // Set defaults for woop fields
        if (options.labelAbove) {
            options.bsc = options.bsc || " ";
            if (options.valueWidth) {
                options.containerWidth = options.containerWidth || +options.valueWidth + 10;
                options.labelWidth = options.labelWidth || options.valueWidth;
            }
            options.labelAbove = z.util.buildDataBindSyntax(options.labelAbove, "text");
        }

        options.label = z.util.buildDataBindSyntax(options.label, "text");
        options.title = z.util.buildDataBindSyntax(options.label, "text");
        options.dataValueField = options.valueField || "Id";
        options.bindValue = z.util.buildDataBindSyntax(options.bindValue, "input");
        options.url = options.url || null;
        options.filterType = options.filterType || "startswith";
        options.containerClasses = options.containerClasses || "";
        options.containerBind = z.util.buildDataBindSyntax(options.containerBind, "container");
        options.bsc = options.bsc || "col-lg-3 col-md-4 col-xs-6";
        options.labelBsc = options.labelBsc || "col-xs-5";
        options.inputBsc = options.inputBsc || "col-xs-7  no-pad";

        options.width = options.width || 500;
        options.filter = options.filter || "startswith";
        options.ignoreCase = !!options.filter || false;
        options.iconType = options.iconType || "";
        options.iconId = options.iconId || "";
        options.iconClasses = options.iconClasses || "";
        options.iconInput = options.iconType ? "icon-input" : "";
        options.systemCode = options.systemCode || false;

        options.dataSource = options.dataSource;
        options.isComboBox = true;

        if (options.requiredRight) {
            options.rightLocked = !userHasRight(options.requiredRight);

            if (options.rightLocked) {
                options.readonly = true;
                options.disabled = true;
                options.classes += " right-locked";
                options.containerClasses += " right-locked";
            }
        }

        // Extrapolate entityType from bindValue
        if (!options.entityType) { // Don't override this.options.entityType when explicitly set by the user.
            var bindValue = "";
            var entityType = null;
            if (typeof options.bindValue == "string") {
                var bValue = options.bindValue.split(":");
                if (bValue.length == 2) {
                    bindValue = options.bindValue.split(":")[1].trim();
                    var lastDot = bindValue.lastIndexOf(".");
                    if (lastDot != -1) {
                        bindValue = bindValue.substring(lastDot + 1);
                    }
                    // Can't assume we'll always have <something>Id for a bindValue
                    if (bindValue.lastIndexOf("Id") == (bindValue.length - 2)) {
                        bindValue = bindValue.substring(0, bindValue.lastIndexOf("Id"));
                    }
                    entityType = bindValue;
                    if (entityType && z.schemas[entityType]) {
                        options.entityType = entityType;
                    }
                }
            }
        }

        if (options.entityType && z.schemas[options.entityType.getStringAfterLastIndexOf(".")]) {
            var schema = z.schemas[options.entityType.getStringAfterLastIndexOf(".")];
            var keys = Object.keys(schema.Properties);
            var primaryProp = "";
            var secondaryProp = "";

            $.each(keys, function (index, key) {
                var prop = schema.Properties[key];
                if (prop.Display == "primary") {
                    primaryProp = key;
                } else if (prop.Display == "secondary") {
                    secondaryProp = key;
                }
            });

            if (primaryProp && secondaryProp) {
                options.labelField = options.labelField || secondaryProp;
                options.bindNumberValue = options.bindNumberValue || primaryProp;
                options.columnHeader1 = primaryProp;
                options.columnHeader2 = secondaryProp == "Value"
                    ? "Description"
                    : secondaryProp;
                options.columnValue1 = primaryProp;
                options.columnValue2 = secondaryProp;
            }
        }

        options.dataTextField = options.labelField || "CodeNumber";
        options.bindNumberValueText = options.bindNumberValue;
        options.bindNumberValue = z.util.buildDataBindSyntax(options.bindNumberValue, "text");
        options.headerTemplate = options.headerTemplate || '<div class="k-dropdown-header">' +
            '<span class="k-widget k-header code-dropdown">' + (z.ll((options.columnHeader1 || "Code")) || "Code") + "</span>" +
            '<span class="k-widget k-header code-dropdown">' + (z.ll((options.columnHeader2 || "Description")) || "Description") + "</span>" +
            "</div>";
        options.template = options.rowTemplate || options.template || '<span name="#= data.' + (options.columnValue1 || "CodeNumber") + ' #" class="k-state-default k-dropdown-option #: (data.Deleted || data.IsDeleted) ? "deleted" : "" #"><span class="code-dropdown">#: data.' +
        (options.columnValue1 || "CodeNumber") + ' #</span><span class="code-dropdown">#: data.' + (options.columnValue2 || "Value") + " #</span></span>";
    }

    create() {
        if (this.options.infoTooltip || this.options.infoTooltipContent) {
            z.controls.toolTip({
                alignX: "center",
                alignY: "top",
                alignTo: "target",
                offsetY: 5,
                selector: $(`#${this.id}_info`),
                content: this.options.infoTooltip ? z.ll(this.options.infoTooltip) : this.options.infoTooltipContent
            });
        }

        var me = this;

        const options = me.options;
        var woopField = options.woopField;

        if (!options.dataSource && options.url) {
            var ds = z.dataSource({
                transport: {
                    read: {
                        url: options.url,
                        contentType: "application/json",
                        dataType: "json"
                    },
                    parameterMap: function (data, type) {
                        var params: any = { $inlinecount: "allpages" };
                        var filterExpression = "";

                        if (options.preFilter) {
                            filterExpression += options.preFilter;
                            if (options.filterFields && options.filterFields.length > 0) {
                                filterExpression += " and (";
                            }
                        }

                        var optionsFilterType; // ??
                        if (options.filterFields && options.filterFields.length > 0) {
                            for (var ii = 0; ii < options.filterFields.length; ii++) {
                                if (options.filterType == "contains") {
                                    filterExpression += "substringOf(" + data.filter.filters[0].value + ", " + options.filterFields[ii] + ")";
                                } else {
                                    filterExpression += optionsFilterType + "(" + options.filterFields[ii] + ", " + data.filter.filters[0].value + ")";
                                }
                            }
                        }

                        if (options.preFilter && options.filterFields && options.filterFields.length > 0) {
                            filterExpression += ")";
                        }

                        if (filterExpression != "") {
                            params.$filter = filterExpression;
                        }

                        return params;
                    }
                }
            });

            options.dataSource = ds;

        }

        options.dataBound = function (e) {
            var listItems = this.list.find(".k-item");

            $.each(listItems, function (i) {
                var elem = $(this);
                if (elem.children(".deleted").length != 0) {
                    elem.hide();
                }
            });
        };

        if (options.entityType == "Division") {
            options.cascade = function (e) {
                var itemIsSelected = this.current();
                var comboBoxIsSearchOptionWithDefault = this.element.data("default") !== undefined; // search option defaults are handled by grid code instead

                if (itemIsSelected || comboBoxIsSearchOptionWithDefault) {
                    return;
                }

                var divisionId = me.options.getDefaultDivisionId
                    ? me.options.getDefaultDivisionId()
                    : z.user.companyData.EmployeeDivisionId;

                var bindData = $("#" + options.id).data("bindData");
                if (bindData && typeof options.bindValue == "string") {
                    var bindValue = options.bindValue.slice(7);

                    // Set to a different value in order to fix an issue where
                    // if if you were already on the default value before
                    // clearing, it would switch to Global instead.
                    if (bindValue == "DivisionNumber") {
                        // This is the case in the reports popup.
                        var divisionNumber = _.find(z.codes.Division, function (d: any) { return d.Id == divisionId; }).DivisionNumber;

                        if (bindData.get(bindValue) == divisionNumber) {
                            bindData.set(bindValue, -1000);
                        }

                        bindData.set(bindValue, divisionNumber);
                    } else {
                        if (bindData.get(bindValue) == divisionId) {
                            bindData.set(bindValue, -1000);
                        }

                        bindData.set(bindValue, divisionId);
                    }
                }
                this.trigger("zRefresh");
            };
        }

        var hasValue = false;
        var valueCaught = "";

        var optionsChange = options.change || z.util.emptyFn;

        var iJustChanged = false;

        options.change = function (e) {
            if (!this.current()) {
                this.value("");
            }

            var dataItem = this.dataItem();
            var nonDeletedItem: any = {};
            var indexToSelect: any = 0;

            if (dataItem && dataItem.IsDeleted) {
                $.each(this.dataSource._data, function (index, item) {
                    var itemValue = item.Value || item.DivisionName;
                    var dataItemValue = dataItem.Value || dataItem.DivisionName;
                    if (!item.IsDeleted && itemValue == dataItemValue) {
                        nonDeletedItem = item;
                        indexToSelect = index;
                        return false;
                    }
                });

                dataItem = nonDeletedItem;

                if (!iJustChanged) {
                    iJustChanged = true;
                    this.select(indexToSelect); // fucking kendo hack!
                    this.trigger("change");
                    this.select(indexToSelect);
                    this.trigger("change");
                    $.wait(10).then(function () {
                        iJustChanged = false;
                    });
                }

            }

            var bindData = $("#" + options.id).data("bindData");

            if (bindData && typeof options.bindValue == "string") {
                var bindValue = options.bindValue.slice(7);

                if (nonDeletedItem.Id) {
                    bindData.set(bindValue, nonDeletedItem.Id);
                }

                var createCode;
                var value = bindData.get(bindValue);
                if (!dataItem && value) {
                    createCode = true;
                } else if (value && value.Id) {
                    value.Id = value.Id == -1 ? undefined : value.Id;
                } else {
                    value = value == -1 ? undefined : value;
                }

                if (!createCode) {
                    var type = $.type(value);

                    if (bindValue.indexOf("Id") != -1 && type == "object") {
                        bindData.set(bindValue, value.Id);
                        hasValue = false;
                        valueCaught = "";
                    } else if (bindValue.indexOf("Id") != -1 && type == "undefined") {
                        bindData.set(bindValue, null);
                        hasValue = false;
                        valueCaught = "";
                    } else if (bindValue.indexOf("Id") != -1 && type == "string") {
                        bindData.set(bindValue, null);
                        hasValue = false;
                        valueCaught = "";
                    } else if (bindValue.indexOf("UDF") != -1 && type == "number") { // Keep udf and normal ids separate for now
                        bindData.set(bindValue, value);
                        hasValue = false;
                        valueCaught = "";
                    } else if (bindValue.indexOf("UDF") != -1 && type == "object") {
                        bindData.set(bindValue, value.Id);
                        hasValue = false;
                        valueCaught = "";
                    } else if (bindValue.indexOf("UDF") != -1 && type == "undefined") {
                        bindData.set(bindValue, null);
                        hasValue = false;
                        valueCaught = "";
                    } else if (bindValue.indexOf("UDF") != -1 && type == "string") {
                        bindData.set(bindValue, null);
                        hasValue = false;
                        valueCaught = "";
                    }
                }
            }

            optionsChange.apply(this, [e]);
        };

        var open = options.open || z.util.emptyFn;

        options.open = function (e) {
            var list = this.list;
            var ul = this.ul;
            var header = this.header;

            $.wait(100).then(function () {
                ul.height("auto");
                var headerHeight = header.outerHeight();
                var listHeight = list.height();

                ul.height(listHeight - headerHeight);
            });

            open.apply(this, [e]);
        };

        var combobox = $("#" + this.id).kendoComboBox(options).data("kendoComboBox");

        if (combobox) {
            if (options.width) {
                combobox.list.width(options.width);
            }

            if (options.disabled && combobox) {
                combobox.enable(!options.disabled);
            }

            if (options.readonly && combobox) {
                combobox.readonly(true);
                $("#" + this.id).readOnly(true);

            } else {
                $("#" + this.id).parents(".k-combobox").find(".k-icon.k-i-arrow-s").removeClass("k-loading");

                combobox.input.on("keyup", function (e) {
                    if (e.keyCode != 13 && e.keyCode != 9) {
                        valueCaught = combobox.input.val();
                    }

                    var grep = $.grep as any;
                    var lis = grep(combobox.ul.children(), function (li) {
                        return $(li).css("display") != "none";
                    });

                    if (lis.length == 0) {
                        combobox.close();
                    }
                });

                combobox.input.on("focusout", function (e) {
                    if ($.trim(valueCaught)) {
                        hasValue = true;
                    }
                });

                combobox.input.on("keydown", function (e) {
                    if ($.trim(valueCaught) && (e.keyCode == 13 || e.keyCode == 9)) {
                        hasValue = true;
                    }
                });

                combobox.wrapper.siblings(".clear-input").on("click", function () {
                    hasValue = false;
                    valueCaught = "";
                });

                combobox.bind("change", function (e) {
                    if (!$.trim(combobox.input.val())) {
                        combobox.value("");
                    }

                    if (woopField) {
                        (combobox as any).woopObservable.change = true;
                    }
                    if (!options.systemCode) {
                        $.wait(100).then(function () {
                            if (hasValue && $.trim(combobox.input.val()) == "" && $.trim(valueCaught)) {
                                combobox.value("");
                                var value = (combobox.options as any).bindValue;
                                var dotIndex = value.lastIndexOf(".") + 1;
                                var colonIndex = value.lastIndexOf(":") + 2;
                                var idIndex = value.lastIndexOf("Id") + 1;
                                var bindValue = value.substr(colonIndex, idIndex - colonIndex - 1);

                                if (dotIndex > colonIndex) {
                                    value = value.substr(dotIndex, idIndex - dotIndex - 1);
                                } else {
                                    value = value.substr(colonIndex, idIndex - colonIndex - 1);
                                }

                                var codeObservable = z.observable({
                                    Value: valueCaught
                                });

                                valueCaught = "";
                                hasValue = false;

                                var buildEditHTML = function () {

                                    z.util.getNewSortOrder({ eType: options.entityType, observable: codeObservable });

                                    var components: ui.Component[] = [
                                        new ui.TextBox({
                                            label: "CodeNumber",
                                            bindValue: "CodeNumber",
                                            required: true,
                                            maxLength: "50"
                                        }),
                                        new ui.TextBox({
                                            label: "Description",
                                            bindValue: "Value",
                                            required: true,
                                            maxLength: "250"
                                        }),
                                        new ui.NumericInput({
                                            label: "SortOrder",
                                            bindValue: "SortOrder",
                                            decimals: "0",
                                            format: "#",
                                            required: true
                                        })
                                    ];
                                    var checkboxes: ui.Checkbox[] = [];

                                    var schema = z.schemas[value];
                                    if (schema) {
                                        var keys = Object.keys(schema.Properties);
                                        var displayFields = $.grep(keys, function (key) {
                                            if (key == "Id" ||
                                                key == "CodeNumber" ||
                                                key == "Value" ||
                                                key == "SortOrder" ||
                                                key == "IsDeleted") {
                                                return false;
                                            }

                                            return schema.Properties[key].Required;
                                        });
                                        $.each(displayFields, function (index, field) {
                                            if (field == "LastUpdatedUserId" || field == "CreatedUserId" || field == "LastUpdatedDateTime" || field == "CreatedDateTime") {
                                                return;
                                            }

                                            var schemaField = schema.Properties[field];
                                            switch (schemaField.Type) {
                                                case "Int16":
                                                    components.push(new ui.NumericInput({
                                                        label: field,
                                                        bindValue: field,
                                                        required: true,
                                                        max: 32767
                                                    }));
                                                    break;
                                                case "Int32":
                                                    components.push(new ui.NumericInput({
                                                        label: field,
                                                        bindValue: field,
                                                        required: true,
                                                        max: 2147483647
                                                    }));
                                                    break;
                                                case "Byte":
                                                    components.push(new ui.NumericInput({
                                                        label: field,
                                                        bindValue: field,
                                                        required: true,
                                                        max: 255
                                                    }));
                                                    break;
                                                case "Decimal":
                                                    components.push(new ui.NumericInput({
                                                        label: field,
                                                        bindValue: field,
                                                        required: true
                                                    }));
                                                    break;
                                                case "Boolean":
                                                    checkboxes.push(new ui.Checkbox({
                                                        label: field,
                                                        bindValue: field,
                                                        required: true
                                                    }));
                                                    break;
                                                case "String":
                                                    if (field == "Color") {
                                                        components.push(new ui.ColorInput({
                                                            label: field,
                                                            bindValue: field,
                                                            required: true
                                                        }));
                                                    } else {
                                                        components.push(new ui.TextBox({
                                                            label: field,
                                                            bindValue: field,
                                                            required: true
                                                        }));
                                                    }
                                                    break;
                                            }
                                        });
                                    }

                                    var layout = new ui.Container({
                                        classes: "code-dynamic-create-container",
                                        components: [
                                            new ui.Container({
                                                classes: "mar-l-13 mar-b-20",
                                                components: checkboxes
                                            }),
                                            new ui.Container({
                                                components: components
                                            })
                                        ]
                                    });
                                    layout.options.zScreen = popUp;

                                    return layout;
                                };

                                var codeName = z.ll(value);
                                var popUp = z.controls.popUp({
                                    id: "CreateCode",
                                    title: z.ll("CreateCodeHeader").format(codeName),
                                    buttons: [
                                        { name: z.ll("Cancel") },
                                        {
                                            name: z.ll("CreateCodeButtonText").format(codeName),
                                            className: "more-pad",
                                            clickEvent: function (evt) {
                                                var validator = popUp.guts.data("kendoValidator");
                                                if (!validator.validate()) {
                                                    var validationMessage = z.util.buildValidationMessage(validator.validationErrors);

                                                    z.controls.alert({
                                                        header: z.ll("ValidationIssues"),
                                                        message: validationMessage,
                                                        messageIsHTML: true,
                                                        type: "danger"
                                                    });

                                                    evt.preventDefault();
                                                    return false;
                                                }

                                                popUp.window.wrapper.mask();

                                                var ajax = z.ajax({
                                                    type: "POST",
                                                    url: "" + value,
                                                    data: codeObservable,
                                                    success: function (data) {
                                                        codeObservable.Id = data.d.results;

                                                        if (z.codes[value]) {
                                                            z.codes[value].push(codeObservable);
                                                        } else {
                                                            z.codes[value] = [codeObservable];
                                                        }
                                                        z.setLocalStorage("codes", JSON.stringify(z.codes));
                                                        // Is this right? Kendo docs say setDataSource only accepts a kendo.data.DataSource, not an array.
                                                        combobox.setDataSource(z.codes[value] as any);
                                                        combobox.select(z.codes[value].length - 1);
                                                        combobox.trigger("change");

                                                        var bindData = $("#" + options.id).data("bindData");

                                                        if (bindData && options.bindValue) {
                                                            bindData.set(bindValue + "Id", codeObservable.Id);
                                                        }
                                                        popUp.window.close();

                                                        if ($("#" + options.id).attr("required")) {
                                                            $("#" + options.id).parent().removeClass("validation-failure");
                                                        }

                                                        if (woopField) {
                                                            (combobox as any).woopObservable.change = false;
                                                            (combobox as any).woopObservable.set(bindValue + "Id", codeObservable.Id);
                                                        }
                                                    }
                                                });

                                                ajax.fail(function (err) {
                                                    var errorCode = z.util.getErrorCode(err);
                                                    if (errorCode == z.errorCode.DuplicateEntryError) {
                                                        z.controls.alert({ message: z.ll("Duplicate").format("code. '" + codeObservable.CodeNumber + "' already exists"), type: "danger" });
                                                        popUp.window.wrapper.unmask();
                                                    } else {
                                                        z.controls.alert({ message: z.ll("IssueCreatingCode"), type: "danger" });
                                                        popUp.window.wrapper.unmask();
                                                    }
                                                });

                                                evt.preventDefault();
                                                return false;
                                            }
                                        }
                                    ]
                                });

                                var codeView = buildEditHTML();
                                codeView.render(popUp.guts);

                                z.bind({ container: popUp.get("#CreateCode"), bind: ".bind-value", data: codeObservable });
                                z.bind({ container: popUp.get("#CreateCode"), bind: ".bind-label", data: z.LocalizedLanguage });

                                popUp.get("#CreateCode").find(".bind-value:first").focus();

                                popUp.guts.zValidator();
                            }
                        });
                    }
                });

                var isOpen = false;
                combobox.bind("open", function () {
                    isOpen = true;
                });

                combobox.bind("close", function () {
                    isOpen = false;
                });

                var updateNumberValue = function (e) {
                    if (options.bindNumberValueText) {
                        var numberField = $(this.wrapper).siblings(".pane-field-number");
                        var selectedIndex = this.select();
                        var data = this.dataSource.data();
                        var dataItem = this.dataItem();

                        numberField.text("");
                        if (dataItem) {
                            numberField.text(dataItem[options.bindNumberValueText]);
                        } else if (numberField.length > 0) {
                            $.each(data, function (index, item) {
                                if (index == selectedIndex) {
                                    numberField.text(item[options.bindNumberValueText]);
                                }
                            });
                        }
                    }
                };

                combobox.bind("dataBound", updateNumberValue);

                combobox.bind("change", updateNumberValue);

                combobox.bind("zRefresh", updateNumberValue);

                $("#" + options.id).data("kendoComboBox").input.tie("click", function () {
                    if ($(this).parent().hasClass("k-state-focused")) {
                        if (isOpen) {
                            combobox.close();
                        } else {
                            combobox.open();
                        }
                    }
                });

                var screenId = z.util.getScreenIdFromElement($("#" + options.id));
                var cbId = "CB_" + screenId.elementId;

                if (screenId.screenId) {
                    cbId = screenId.screenId + "_" + cbId;
                }

                combobox.input.attr("id", cbId);
            }
        }
    }

}
